import { ArrowRight } from "lucide-react";

export default function AboutStory({ fields = {} }) {
  const {
    eyebrow = "Our Story",
    headline = "Born from a passion for the perfect round",
    paragraph1 = "Exqura was founded by a group of avid golfers who were frustrated by the complexity of planning international golf trips. Booking tee times across time zones, coordinating transfers, finding the right hotel — it was all too fragmented.",
    paragraph2 = "We built Exqura to change that. Today, we offer a single platform where golfers can discover, book, and experience the finest courses across Asia — all in seconds, all in one place.",
    ctaLabel = "Read our full story",
    ctaHref = "#",
    image = "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=1200&q=80",
  } = fields;

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-[#D4AF37] text-sm font-semibold tracking-widest uppercase mb-3">
              {eyebrow}
            </p>
            <h2 className="text-white font-bold text-3xl sm:text-4xl mb-6 leading-tight">
              {headline}
            </h2>
            <p className="text-white/60 text-base leading-relaxed mb-4 whitespace-pre-line">
              {paragraph1}
            </p>
            <p className="text-white/60 text-base leading-relaxed mb-6 whitespace-pre-line">
              {paragraph2}
            </p>
            <a
              href={ctaHref}
              className="inline-flex items-center gap-2 text-[#D4AF37] font-semibold text-sm hover:gap-3 transition-all"
            >
              {ctaLabel} <ArrowRight className="w-4 h-4" />
            </a>
          </div>
          <div className="rounded-3xl overflow-hidden shadow-2xl h-80 lg:h-96">
            <img
              src={image}
              alt="Golf course"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
